<template> 
  <div class="container">
    <div class="page-header">
      <h1 class="page-title full">
        Gérer les horaires des collectes<br>
        <p class="lead text-muted">Modifiez les horaires et les zones associées au collectes.</p>
      </h1>

      <div class="page-options d-flex">
        <div class="input-group ml-3 pl-3">
          <router-link :to="{ name: 'Horaires.ajouter'}" class="btn btn-secondary btn-md"> 
            <i class="fe fe-plus"></i> Créer un horaire
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-cards">
      <div class="col-12" v-if="loading"><Spinner></Spinner></div>
      <div class="col-12" v-else>
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Horaires</h3>
          </div>
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap">
              <thead>
                <tr>
                  <th style="width: 50%;">Nom de l'horaire</th>
                  <th>Date d'édition</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-model="horaires" :options="{handle:'.draggable'}">
                <tr v-for="horaire in horaires" class="clickable" :key="horaire.id"
                    v-on:click.prevent="naviguerHoraire(horaire)">
                  <td>
                    <router-link :to="{ name: 'Horaires.modifier', params: { id: horaire.id }}"> 
                      {{ horaire.nom }}
                    </router-link>            
                  </td>
                  <td>
                    {{ prettyTime(horaire.updated_at, "LLL") }}
                  </td>
                  <td class="text-right">
                    <router-link :to="{ name: 'Horaires.modifier', params: { id: horaire.id }}"
                        class="btn btn-secondary btn-sm"> 
                      Modifier
                    </router-link>
                  </td>
                </tr>
                <tr v-if="horaires.length == 0" class="text-muted">
                  <td colspan="5"><i>Il n'y a aucun horaire.</i></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { prettyTime } from '../helpers'
  import arraySort from 'array-sort'
  import Spinner from 'vue-simple-spinner'

  export default {
    components: {
      Spinner,
    },
    data() {
      return {
        loading: true,
        horaires: [],
      }
    },
    created () {
      var self = this;
      this.$store.commit("setTitle", "Horaires");

      Promise.all([ 
        self.$http.get('horaires') 
      ]).then(function([ horaires ]) {
        if (horaires && horaires.body && horaires.body.data) {
          self.horaires = horaires.body.data;
        }
        self.loading = false;
      })
      .catch(function(err){
        console.log(err);
      });

    },
    computed: {
      
    },
    methods: {
      prettyTime,

      naviguerHoraire(horaire) {
        this.$router.push({ 
          name: 'Horaires.modifier', 
          params: { id: horaire.id } 
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Horaires.vue?34e085a2